import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
    CreateRentalArrivalTimePayload,
    UpdateRentalArrivalTimePayload,
} from '../arrivalTime.types';
import {
    getArrivalTime,
    createRentalArrivalTime,
    updateRentalArrivalTime,
} from './arrivalTime.api';

export const useGetRentalArrivalTimeKey = 'useGetRentalArrivalTimeKey';

export const useGetRentalArrivalTime = () => {
    const { isLoading, isError, data, error } = useQuery({
        queryKey: [useGetRentalArrivalTimeKey],
        queryFn: getArrivalTime,
    });

    return { isLoading, isError, data, error };
};

export const useCreateRentalArrivalTime = () => {
    const queryClient = useQueryClient();

    const { mutate, isPending, isError } = useMutation({
        mutationFn: (payload: CreateRentalArrivalTimePayload) =>
            createRentalArrivalTime(payload),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [useGetRentalArrivalTimeKey] });
        },
    });

    return { mutate, isPending, isError };
};

export const useUpdateRentalArrivalTime = () => {
    const queryClient = useQueryClient();

    const { mutate, isPending, isError } = useMutation({
        mutationFn: ({ rentalArrivalTimeId, payload }: { rentalArrivalTimeId: string; payload: UpdateRentalArrivalTimePayload }) => {
            return updateRentalArrivalTime(rentalArrivalTimeId, payload);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [useGetRentalArrivalTimeKey] });
        },
    });

    return { mutate, isPending, isError };
};
